import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../pages/login_cadastro/LoginPage/index.tsx";
import MenuPage from "../pages/menus/MenuPage";
import ProtectedRoute from "./ProtectedRoute.tsx";
import AdminRoute from "./AdminRoute.tsx";
import EnterpriseRoute from "./EnterpriseRoute.tsx";
import RoleRoute from "./RoleRoute.tsx";
import PermissaoRoute from "./PermissaoRoute.tsx";
import LogAtividades from "../pages/Relatorios/LogAtividades.tsx";
import SetupPage from "../pages/login_cadastro/SetupPage";
import RedefinirSenhaPage from "../pages/login_cadastro/RedefinirSenhaPage/index.tsx";
import CadastroCirurgiaPage from "../pages/Cirurgias/index.tsx";
import ListaCirurgias from "../pages/Cirurgias/listagemCirurgia.tsx";
import ListaTipoCirurgias from "../pages/TipoCirurgia/listagemTipoCirurgia.tsx";
import ListaConvenios from "../pages/Convenio/listagemConvenio.tsx";
import ListagemHospital from "../pages/Hospital/listagemHospital.tsx";
import ListagemInstrumentador from "../pages/Instrumentador/listagemInstrumentador.tsx";
import PerfilInstrumentador from "../pages/Instrumentador/perfilInstrumentador.tsx";
import ListagemMedico from "../pages/Medico/listagemMedico.tsx";
import PerfilMedico from "../pages/Medico/perfilMedico.tsx";
import ListagemPaciente from "../pages/Paciente/listagemPaciente.tsx";
import PerfilPaciente from "../pages/Paciente/perfilPaciente.tsx";
import PlanosPage from "../pages/Planos/index.tsx";
import MeuPlanoPage from "../pages/MeuPlano/index.tsx";
import PainelAdministrativoPage from "../pages/Admin/PainelAdministrativo.tsx";
import DashboardPage from "../pages/Dashboard/index.tsx";
import AgendaPage from "../pages/Agenda/index.tsx";
import ConfiguracoesPage from "../pages/Configuracoes/index.tsx";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Rotas públicas */}
      <Route path="/" element={<LoginPage />} />
      {/* Destino do link de "esqueci minha senha" — quem chega aqui está deslogado
          por definição; quem autoriza a troca é o token da query string. */}
      <Route path="/redefinir-senha" element={<RedefinirSenhaPage />} />

      {/* Rotas protegidas */}
      <Route
        path="/setup"
        element={
          <ProtectedRoute>
            <SetupPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/menu"
        element={
          <ProtectedRoute>
            <MenuPage darkMode={false} />
          </ProtectedRoute>
        }
      />
      <Route
        // path="/api"
        // element={
        //   <ProtectedRoute>
        //     {/* <PremiumPage> */}
        //     <ApiDocsPage />
        //     {/* </PremiumPage> */}
        //   </ProtectedRoute>
        // }
      />
      <Route
        path="/cirurgia"
        element={
          <ProtectedRoute>
            <CadastroCirurgiaPage />
          </ProtectedRoute>
        }
      />
      <Route
        // Rota antiga: a gestão de usuários virou aba de Configurações. Mantida
        // como redirecionamento porque está em links e favoritos de quem já usa
        // o sistema — deixá-la morta seria uma regressão silenciosa.
        path="/usuario/listagem"
        element={<Navigate to="/configuracoes?aba=usuarios" replace />}
      />
      <Route
        path="/cirurgias"
        element={
          <ProtectedRoute>
            <ListaCirurgias darkMode={false} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/convenio/listagem"
        element={
          <ProtectedRoute>
            <ListaConvenios darkMode={false} />
          </ProtectedRoute>
        }
      />

      <Route
        path="/tipo-cirurgia/listagem"
        element={
          <ProtectedRoute>
            <ListaTipoCirurgias darkMode={false} />
          </ProtectedRoute>
        }
      />

      <Route
        path="/hospital/listagem"
        element={
          <ProtectedRoute>
            <ListagemHospital darkMode={false} />
          </ProtectedRoute>
        }
      />

      <Route
        path="/instrumentador/listagem"
        element={
          <ProtectedRoute>
            <ListagemInstrumentador darkMode={false} />
          </ProtectedRoute>
        }
      />

      <Route
        path="/instrumentador/:id/perfil"
        element={
          <ProtectedRoute>
            <PerfilInstrumentador />
          </ProtectedRoute>
        }
      />

      <Route
        path="/medico/listagem"
        element={
          <ProtectedRoute>
            <ListagemMedico darkMode={false} />
          </ProtectedRoute>
        }
      />

      <Route
        path="/medico/:id/perfil"
        element={
          <ProtectedRoute>
            <PerfilMedico />
          </ProtectedRoute>
        }
      />

      <Route
        path="/paciente/listagem"
        element={
          <ProtectedRoute>
            <ListagemPaciente darkMode={false} />
          </ProtectedRoute>
        }
      />

      <Route
        path="/paciente/:id/perfil"
        element={
          <ProtectedRoute>
            <PerfilPaciente />
          </ProtectedRoute>
        }
      />

      <Route
        path="/planos/listagem"
        element={
          <ProtectedRoute>
            <PlanosPage darkMode={false} />
          </ProtectedRoute>
        }
      />
      {/* Assinatura e faturas sao de ADM: PLANO_GERENCIAR ja e so-ADM no
          servidor e a sidebar ja esconde o link. Faltava fechar a URL direta -
          um nao-ADM chegava na tela, que entao buscava /usuario/listar. */}
      <Route
        path="/meu-plano"
        element={
          <ProtectedRoute>
            <RoleRoute permitidos={["ADM"]}>
              <MeuPlanoPage />
            </RoleRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <PainelAdministrativoPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <RoleRoute permitidos={["ADM", "OPERADOR"]}>
              <EnterpriseRoute>
                <DashboardPage />
              </EnterpriseRoute>
            </RoleRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/relatorios/log-atividades"
        element={
          <ProtectedRoute>
            <PermissaoRoute exige="podeVerLog">
              <LogAtividades />
            </PermissaoRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/agenda"
        element={
          <ProtectedRoute>
            <AgendaPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/configuracoes"
        element={
          <ProtectedRoute>
            <ConfiguracoesPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
// Production deploy.
